import { font, uTransparentLink } from 'modules/styles';
import ExchangeRate from 'pages/requestList/components/ExchangeRate/ExchangeRate';
import styled from 'styled-components';

export const Footer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 12px;
`;

export const OperInOriginLink = styled.a`
    display: flex;
    align-items: center;
    cursor: pointer;

    ${uTransparentLink};
`;

export const OpenInOriginLinkText = styled.div`
    margin-left: 5px;

    ${font(13, '#000')}
`;

export const StyledExchangeRate = styled(ExchangeRate)`
    margin-bottom: 30px;
    ${font(11, '#565656', 'semibold')}
`;
